// #MODULE - IntersectionObserver
// > Authors: Michael Moir
// >
// > Create Date: Dec, 2018
// >
// ##DESCRIPTION: This module can be used to wrap and expose IntersectionObserver patterns and capabilities.
//

export default class IntersectionObserver {
  constructor(intersect, options = {}) {
    if (typeof intersect !== 'function') {
      throw new Error('IntersectionObserver requires `intersect` - the function to fire whenever `el` is intersected');
    }

    const opts = Object.assign({
      rootMargin: '0px',
      threshold: 0.1,
    }, options);

    this.ready = import(/* webpackChunkName: "intersectionObserverPolyfill" */ './polyfill')
      .then(polyfillPromise => polyfillPromise.default)
      .then((IntersectionObserverPolyfill) => {
        this.io = new IntersectionObserverPolyfill((entries) => {
          entries.forEach(({ target, intersectionRatio }) => {
            if (intersectionRatio > 0) {
              intersect(target, this);
            }
          });
        }, opts);
      });
  }

  subscribe(nodes) {
    this._toArray(nodes).forEach(node => this.io.observe(node));
  }

  unsubscribe(nodes) {
    this._toArray(nodes).forEach(node => this.io.unobserve(node));
  }

  destroy() {
    this.io.disconnect();
  }

  _toArray(nodes) {
    if (Array.isArray(nodes)) return nodes;

    if (nodes instanceof NodeList) return [].slice.call(nodes);

    if (nodes instanceof HTMLElement) return [nodes];

    return [];
  }
}



// WEBPACK FOOTER //
// ../util/intersection-observer/index.js